/* Savarela (repris de Dravella le 21/10/2026) — garde-fou des lots « une ligne par article » (17/10/2026).
   Un lot (2, 3, 4 articles) arrive en N lignes au prix d'UN article du lot. Si la cliente retire une ligne
   ou change une quantité, le reste du lot ne vaut plus le prix du lot : les unités en trop repassent
   sur la variante normale (prix plein). Rien d'autre n'est touché. */
(() => {
  const G = [
    { m: [56379530215766], n: 4, // Gamelle PawLift 2 + 2 (29/10)
      s: (v) => ({ 56379530215766: 56379530182998 })[v] },
    { m: [56378251608406, 56378251706710, 56378251805014, 56378967884118], n: 4, // CozyPod 2 + 2 (29/10, couleur par support, 4 coloris)
      s: (v) => ({ 56378251608406: 56378251575638, 56378251706710: 56378251673942, 56378251805014: 56378251772246, 56378967884118: 56378967851350 })[v] },
    { m: [56378251641174, 56378251739478, 56378251837782, 56378967916886], n: 6, // CozyPod 3 + 3 (29/10, couleur par support, 4 coloris)
      s: (v) => ({ 56378251641174: 56378251575638, 56378251739478: 56378251673942, 56378251837782: 56378251772246, 56378967916886: 56378967851350 })[v] },
    { m: [56214666445142], n: 2, s: () => 56214666412374 },                    // Smoker Kit lot de 2
    { m: [55931687141718], n: 2, s: () => 55931687108950 },                    // Cap Washer lot de 2
    { m: [55931687174486, 55931687207254], n: 3, s: () => 55931687108950 },    // Cap Washer lot de 3
    { m: [56215001727318], n: 4, s: () => 56215001694550 },                    // Meatball Spoon 2 + 2
    { m: [56215001760086], n: 6, s: () => 56215001694550 },                     // Meatball Spoon 3 + 3
    { m: [56215542169942, 56215542235478, 56215542301014, 56215542366550, 56215542432086, 56215542497622, 56215542563158], n: 2, // Root Concealer 1 + 1 (teinte par stick)
      s: (v) => ({ 56215542169942: 56215542137174, 56215542235478: 56215542202710, 56215542301014: 56215542268246, 56215542366550: 56215542333782, 56215542432086: 56215542399318, 56215542497622: 56215542464854, 56215542563158: 56215542530390 })[v] },
    { m: [56277157413206], n: 3, s: () => 56277157380438 },                    // Gel Polish Pen 3 stylos (2 + 1)
    { m: [56277157445974], n: 5, s: () => 56277157380438 }, // Gel Polish Pen 5 stylos (3 + 2)
    { m: [56280999854422, 56280999919958, 56280999985494, 56281000051030, 56281000116566, 56281000182102], n: 2, // Serpent Necklace 2 colliers (couleur par collier)
      s: (v) => ({ 56280999854422: 56280999821654, 56280999919958: 56280999887190, 56280999985494: 56280999952726, 56281000051030: 56281000018262, 56281000116566: 56281000083798, 56281000182102: 56281000149334 })[v] },
    { m: [56281103499606, 56281103565142, 56281103630678], n: 2, // Two Initials Ring 2 bagues (couleur + initiales par bague)
      s: (v) => ({ 56281103499606: 56281103466838, 56281103565142: 56281103532374, 56281103630678: 56281103597910 })[v] }
  ];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const F = window.fetch.bind(window);
  let busy = false;

  async function guard() {
    if (busy) return; busy = true;
    try {
      const cart = await F(root + "cart.js").then((r) => r.json());
      let changed = false;
      for (const g of G) {
        const lines = cart.items.filter((i) => g.m.includes(i.variant_id));
        let extra = lines.reduce((a, i) => a + i.quantity, 0) % g.n;
        for (let k = lines.length - 1; k >= 0 && extra > 0; k--) {
          const l = lines[k], take = Math.min(extra, l.quantity);
          await F(root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: l.key, quantity: l.quantity - take }) });
          const items = []; for (let t = 0; t < take; t++) items.push({ id: g.s(l.variant_id), quantity: 1, properties: Object.assign({}, l.properties || {}, { _l: "solo" }) });
          await F(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items }) });
          extra -= take; changed = true;
        }
      }
      if (changed) {
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        const dr = document.querySelector("cart-drawer");
        if (dr && dr.getSectionsToRender && dr.renderContents) {
          const ids = dr.getSectionsToRender().map((s) => s.id);
          const sections = await F(location.pathname + "?sections=" + ids.join(",")).then((r) => r.json());
          dr.renderContents({ sections });
        }
      }
    } catch (e) {} finally { busy = false; }
  }

  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const p = F(input, init);
    if (!busy && /\/cart\/(change|update)(\.js)?/.test(url)) p.then(() => setTimeout(guard, 150));
    return p;
  };
  if (document.readyState !== "loading") guard(); else document.addEventListener("DOMContentLoaded", guard);
})();
